<div class="visitor-registration-summary">
    <h1>{{'Sicherheitsbelehrung' | translate:
        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.title',
        translationService.language]}}</h1>

    <p *ngIf="isUsingSmartphone">{{'' | translate:
        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.description',
        translationService.language]}}</p>

    <mat-card>
        <table>
            <tr>
                <td class="label"><label>{{'Numberplate' | translate:
                        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.numberPlate',
                        translationService.language]}}:</label></td>
                <td class="bold">{{numberPlate}}</td>
            </tr>
            <tr>
                <td class="label"><label>{{'Company' | translate:
                        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.company',
                        translationService.language]}}:</label></td>
                <td class="bold">{{company}}</td>
            </tr>
            <tr>
                <td class="label"><label>{{'Name' | translate:
                        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.name',
                        translationService.language]}}:</label></td>
                <td class="bold">{{name}}</td>
            </tr>
            <tr>
                <td class="label"><label>{{'Firstname' | translate:
                        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.label.firstname',
                        translationService.language]}}:</label></td>
                <td class="bold">{{firstname}}</td>
            </tr>
        </table>
        <ng-container *ngIf="hasSummaryHints()">
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <div class="hint">
                {{'Hinweise' | translate:
                        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.hints', translationService.language]}}
            </div>
        </ng-container>
        <ng-container *ngFor="let infoText of informationTexts; let first = first">
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <div class="hint">
                <sc-padding>
                    {{'Hinweise' | translate: [infoText, translationService.language]}}
                </sc-padding>
            </div>
        </ng-container>
        <ng-container *ngIf="showHintForGrandAreaAccessByCar">
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <div class="hint">
                <sc-padding>
                    {{'Hinweis zu Zufahrt' | translate: [accessByCarHintDictionaryKey, translationService.language]}}
                </sc-padding>
            </div>
        </ng-container>
    </mat-card>

    <h1
        *ngIf="this.translationService.translationExists('tmc-yard.widgets.registration-terminal.visitor-registration-summary.info', this.translationService.language)">
        {{'' | translate:
        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.info',
        translationService.language]}}</h1>

    <div class="success">
        <sc-icon iconClass="fa-check-circle"></sc-icon>
    </div>

    <p class="gatekeeper-hint" *ngIf="gatekeeperMandatory">{{'gatekeeperMandatory' | translate:
        ['tmc-yard.widgets.registration-terminal.visitor-registration-summary.hint', translationService.language]}}
    </p>
</div>
